import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "penalty-block-manager" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "panel-title" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "card bg-dark text-light" }
const _hoisted_9 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "mb-0 text-light" }
const _hoisted_11 = { class: "d-flex gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row mb-3 g-2" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { value: "" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { value: "" }
const _hoisted_23 = { value: "active" }
const _hoisted_24 = { value: "inactive" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { value: "code" }
const _hoisted_27 = { value: "name" }
const _hoisted_28 = { value: "severity" }
const _hoisted_29 = { value: "category" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = { class: "table table-dark table-hover" }
const _hoisted_32 = { class: "text-info" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_35 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_36 = { class: "btn-group btn-group-sm" }
const _hoisted_37 = ["onClick", "title"]
const _hoisted_38 = ["onClick", "title", "aria-label"]
const _hoisted_39 = ["onClick", "title"]
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = { class: "modal-title" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = {
  for: "blockCode",
  class: "form-label"
}
const _hoisted_45 = ["disabled", "placeholder"]
const _hoisted_46 = { class: "form-text text-muted" }
const _hoisted_47 = { class: "invalid-feedback" }
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = { class: "form-label" }
const _hoisted_50 = { class: "row g-2" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "input-group" }
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "input-group" }
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = { class: "form-label" }
const _hoisted_60 = { class: "row g-2" }
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "input-group" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "input-group" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = { class: "row mb-3" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = {
  for: "blockCategory",
  class: "form-label"
}
const _hoisted_70 = { value: "" }
const _hoisted_71 = { value: "warning" }
const _hoisted_72 = { value: "ban" }
const _hoisted_73 = { value: "fine" }
const _hoisted_74 = { value: "restriction" }
const _hoisted_75 = { value: "penalty" }
const _hoisted_76 = { value: "item" }
const _hoisted_77 = { value: "other" }
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = {
  for: "blockSeverity",
  class: "form-label"
}
const _hoisted_80 = { class: "d-flex align-items-center gap-3" }
const _hoisted_81 = { class: "invalid-feedback" }
const _hoisted_82 = { class: "mb-3" }
const _hoisted_83 = { class: "form-check form-switch" }
const _hoisted_84 = {
  class: "form-check-label",
  for: "blockActive"
}
const _hoisted_85 = { class: "modal-footer" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_88 = { class: "modal-header" }
const _hoisted_89 = { class: "modal-title" }
const _hoisted_90 = { class: "modal-body" }
const _hoisted_91 = { class: "modal-footer" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_94 = { class: "toast-container position-fixed bottom-0 end-0 p-3" }
const _hoisted_95 = { class: "toast-header bg-dark text-light" }
const _hoisted_96 = { class: "me-auto" }
const _hoisted_97 = { class: "toast-body bg-dark text-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StateBlock = _resolveComponent("StateBlock")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('penalty.management.title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('penalty.blocks')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('penalty.blocks')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshBlocks && _ctx.refreshBlocks(...args))),
                class: "btn btn-outline-secondary btn-sm",
                disabled: _ctx.loading
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(['fas fa-sync-alt', { 'fa-spin': _ctx.loading }])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('penalty.refresh')), 1)
              ], 8, _hoisted_12),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args))),
                class: "btn btn-primary btn-sm"
              }, [
                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('penalty.management.create')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-text bg-dark text-light border-secondary" }, [
                    _createElementVNode("i", { class: "fas fa-search" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control bg-dark text-light border-secondary",
                    placeholder: _ctx.$t('penalty.search_blocks'),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                  }, null, 40, _hoisted_17), [
                    [_vModelText, _ctx.searchQuery]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-dark text-light border-secondary",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.categoryFilter) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, [
                  _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('penalty.all_categories')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: category,
                      value: category
                    }, _toDisplayString(_ctx.formatCategory(category)), 9, _hoisted_20))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.categoryFilter]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-dark text-light border-secondary",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.statusFilter) = $event)),
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, [
                  _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t('common.all')), 1),
                  _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t('penalty.statusActive')), 1),
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t('penalty.statusInactive')), 1)
                ], 544), [
                  [_vModelSelect, _ctx.statusFilter]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-dark text-light border-secondary",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sortBy) = $event)),
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('penalty.management.code')), 1),
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('ticket.title')), 1),
                  _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t('penalty.severity')), 1),
                  _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('penalty.management.category')), 1)
                ], 544), [
                  [_vModelSelect, _ctx.sortBy]
                ])
              ])
            ]),
            _createVNode(_component_StateBlock, {
              loading: _ctx.loading,
              empty: _ctx.filteredBlocks.length === 0,
              "empty-text": _ctx.$t('penalty.no_blocks'),
              "loading-text": _ctx.$t('common.loading')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("table", _hoisted_31, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('penalty.management.code')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('ticket.title')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('penalty.management.category')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('penalty.severity')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('ticket.status')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('actions')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredBlocks, (block) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: block._id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("code", _hoisted_32, _toDisplayString(block.code), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.blockName(block)), 1),
                            (_ctx.blockAltName(block))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", _hoisted_33, _toDisplayString(_ctx.blockAltName(block)), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (block.category)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["badge", _ctx.getCategoryBadgeClass(block.category)])
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass([_ctx.getCategoryIcon(block.category), "me-1"])
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatCategory(block.category)), 1)
                                ], 2))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
                          ]),
                          _createElementVNode("td", null, [
                            (block.severity)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["badge", _ctx.getSeverityBadgeClass(block.severity)])
                                }, _toDisplayString(block.severity) + "/10 ", 3))
                              : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", block.isActive ? 'bg-success' : 'bg-danger'])
                            }, _toDisplayString(block.isActive ? _ctx.$t('penalty.statusActive') : _ctx.$t('penalty.statusInactive')), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.openEditModal(block)),
                                class: "btn btn-outline-secondary",
                                title: _ctx.$t('penalty.management.edit')
                              }, [...(_cache[30] || (_cache[30] = [
                                _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                              ]))], 8, _hoisted_37),
                              (block.isActive)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.confirmDeactivate(block)),
                                    class: "btn btn-outline-danger",
                                    title: _ctx.$t('penalty.management.deactivate'),
                                    "aria-label": _ctx.$t('penalty.management.deactivate')
                                  }, [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("i", { class: "fas fa-ban" }, null, -1)
                                  ]))], 8, _hoisted_38))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.activateBlock(block)),
                                    class: "btn btn-outline-secondary",
                                    title: _ctx.$t('penalty.management.activate')
                                  }, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("i", { class: "fas fa-check" }, null, -1)
                                  ]))], 8, _hoisted_39))
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading", "empty", "empty-text", "loading-text"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_BaseModal, {
      show: _ctx.showBlock,
      onClose: _ctx.hideModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("h5", _hoisted_41, _toDisplayString(_ctx.isEditing ? _ctx.$t('penalty.management.edit') : _ctx.$t('penalty.management.create')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("form", {
            onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveBlock && _ctx.saveBlock(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('penalty.management.code')) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control bg-dark text-light", {'is-invalid': _ctx.errors.code}]),
                id: "blockCode",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.blockForm.code) = $event)),
                disabled: _ctx.isEditing,
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.formatCode && _ctx.formatCode(...args))),
                placeholder: _ctx.$t('panel.penaltyBlocks.codePlaceholder')
              }, null, 42, _hoisted_45), [
                [_vModelText, _ctx.blockForm.code]
              ]),
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('penalty.management.code_help')), 1),
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.errors.code), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('ticket.title')) + " *", 1),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "input-group-text bg-dark text-light border-secondary" }, "EN", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control bg-dark text-light", {'is-invalid': _ctx.errors.nameEn}]),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.blockForm.name.en) = $event)),
                      placeholder: _ctx.$t('penalty.management.name_en')
                    }, null, 10, _hoisted_53), [
                      [_vModelText, _ctx.blockForm.name.en]
                    ])
                  ]),
                  (_ctx.errors.nameEn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.errors.nameEn), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "input-group-text bg-dark text-light border-secondary" }, "ES", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control bg-dark text-light",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.blockForm.name.es) = $event)),
                      placeholder: _ctx.$t('penalty.management.name_es')
                    }, null, 8, _hoisted_57), [
                      [_vModelText, _ctx.blockForm.name.es]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('ticket.description')), 1),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "input-group-text bg-dark text-light border-secondary" }, "EN", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control bg-dark text-light",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.blockForm.description.en) = $event)),
                      rows: "2",
                      placeholder: _ctx.$t('penalty.management.description_en')
                    }, null, 8, _hoisted_63), [
                      [_vModelText, _ctx.blockForm.description.en]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "input-group-text bg-dark text-light border-secondary" }, "ES", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control bg-dark text-light",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.blockForm.description.es) = $event)),
                      rows: "2",
                      placeholder: _ctx.$t('penalty.management.description_es')
                    }, null, 8, _hoisted_66), [
                      [_vModelText, _ctx.blockForm.description.es]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('penalty.management.category')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-dark text-light",
                  id: "blockCategory",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.blockForm.category) = $event))
                }, [
                  _createElementVNode("option", _hoisted_70, _toDisplayString(_ctx.$t('penalty.all_categories')), 1),
                  _createElementVNode("option", _hoisted_71, _toDisplayString(_ctx.$t('penalty.categories.warning')), 1),
                  _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('penalty.categories.ban')), 1),
                  _createElementVNode("option", _hoisted_73, _toDisplayString(_ctx.$t('penalty.categories.fine')), 1),
                  _createElementVNode("option", _hoisted_74, _toDisplayString(_ctx.$t('penalty.categories.restriction')), 1),
                  _createElementVNode("option", _hoisted_75, _toDisplayString(_ctx.$t('penalty.categories.penalty')), 1),
                  _createElementVNode("option", _hoisted_76, _toDisplayString(_ctx.$t('penalty.categories.item')), 1),
                  _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.$t('penalty.categories.other')), 1)
                ], 512), [
                  [_vModelSelect, _ctx.blockForm.category]
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('penalty.severity')) + " (1-10)", 1),
                _createElementVNode("div", _hoisted_80, [
                  _withDirectives(_createElementVNode("input", {
                    type: "range",
                    class: "form-range flex-grow-1",
                    id: "blockSeverity",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.blockForm.severity) = $event)),
                    min: "1",
                    max: "10",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.blockForm.severity,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.getSeverityBadgeClass(_ctx.blockForm.severity)]),
                    style: {"min-width":"50px"}
                  }, _toDisplayString(_ctx.blockForm.severity) + "/10 ", 3)
                ]),
                _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.errors.severity), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "blockActive",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.blockForm.isActive) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.blockForm.isActive]
                ]),
                _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('penalty.management.is_active')), 1)
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
          }, _toDisplayString(_ctx.$t('cancel')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.saveBlock && _ctx.saveBlock(...args))),
            disabled: _ctx.saving
          }, [
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_87))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? _ctx.$t('common.save') : _ctx.$t('penalty.management.create')), 1)
          ], 8, _hoisted_86)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    _createVNode(_component_BaseModal, {
      show: !!_ctx.blockToDeactivate,
      size: "sm",
      onClose: _ctx.hideDeactivateModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("h5", _hoisted_89, _toDisplayString(_ctx.$t('common.confirm')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideDeactivateModal && _ctx.hideDeactivateModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('penalty.management.confirm_deactivate')), 1),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.blockToDeactivate?.code), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideDeactivateModal && _ctx.hideDeactivateModal(...args)))
          }, _toDisplayString(_ctx.$t('cancel')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.deactivateBlock && _ctx.deactivateBlock(...args))),
            disabled: _ctx.saving
          }, [
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_93))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('penalty.management.deactivate')), 1)
          ], 8, _hoisted_92)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    _createElementVNode("div", _hoisted_94, [
      _createElementVNode("div", {
        class: _normalizeClass(["toast", {'show': _ctx.showToast}]),
        role: "alert",
        ref: "toastElement"
      }, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("i", {
            class: _normalizeClass([_ctx.toastIcon, "me-2"])
          }, null, 2),
          _createElementVNode("strong", _hoisted_96, _toDisplayString(_ctx.toastTitle), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showToast = false))
          })
        ]),
        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.toastMessage), 1)
      ], 2)
    ])
  ]))
}